import React from 'react';
import { LoadingBalls, Overlay } from '@moda/om';
import { usePayPalButton } from '../../hooks/usePayPalButton';

import './PayPalButton.scss';

const PAYPAL_BUTTON_ID = 'paypal-button';

const HEIGHTS = {
  small: 32,
  large: 48
};

type Props = {
  size?: 'small' | 'large';
  paypalClientToken: string | null;
  onSelect?: () => Promise<void>;
  id?: string;
};

export const PayPalButton: React.FC<Props> = ({
  size = 'large',
  paypalClientToken,
  onSelect,
  id = PAYPAL_BUTTON_ID
}) => {
  const { loading } = usePayPalButton({
    paypalClientToken,
    elementSelector: `#${id}`,
    height: HEIGHTS[size],
    onSubmit: onSelect
  });

  return (
    <div className={`PayPalButton PayPalButton--${size}`}>
      <div id={id} data-testid="paypalButton" />

      <Overlay className="PayPalButton__overlay" show={loading}>
        <LoadingBalls />
      </Overlay>
    </div>
  );
};
